
import React from 'react';
import { Typography } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessageDefault: React.FC<MessageProps> = ({ message }) => {
  return (
    <>
      <Typography variant="body2">
        {JSON.stringify(message?.content || 'Message type not found')}
      </Typography>
    </>
  );
};

export default MessageDefault;
